import { useMemo } from 'react';

export const AccessLevel = Object.freeze({
    MERCHANT: 'merchant',
    OPERATOR: 'operator',
    ADMIN: 'admin'
});

export function useAuth() {
    // Pobierz profil z localStorage i sparsuj
    const profile = useMemo(() => {
        try {
            const raw = localStorage.getItem('profile');
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            return null;
        }
    }, [localStorage.getItem('profile')]);

    // Sprawdź, czy użytkownik ma daną rolę/uprawnienie
    const isUserInRole = (role) => {
        if (!profile || !profile.permissions) return false;
        return profile.permissions.includes(role);
    };

    // Sprawdź, czy użytkownik ma jakąkolwiek z podanych ról/uprawnień
    const isUserInAnyRole = (roles) => {
        if (!profile || !profile.permissions) return false;
        return roles.some(role => profile.permissions.includes(role));
    };

    // Określ rolę użytkownika na podstawie merchant i operator
    const getAccessLevel = () => {
        if (!profile) {
            return null;
        }
        // Jeśli operator nie jest null, użytkownik jest operatorem (priorytet nad merchantem)
        if (getOperator() !== null && getOperator().id !== null) {
            return AccessLevel.OPERATOR;
        }

        // Jeśli merchant nie jest null, użytkownik jest merchantem
        if (getMerchant() !== null && getMerchant().id !== null) {
            return AccessLevel.MERCHANT;
        }

        // Jeśli ani merchant ani operator nie są ustawione, użytkownik jest adminem
        return AccessLevel.ADMIN;
    };

    const isMerchantAccessLevel = () => {
        return getAccessLevel() === AccessLevel.MERCHANT;
    }

    const isOperatorAccessLevel = () => {
        return getAccessLevel() === AccessLevel.OPERATOR;
    }

    const isAdminAccessLevel = () => {
        return getAccessLevel() === AccessLevel.ADMIN;
    }

    const getUserId = () => profile?.id || null;
    const getUserAvatarId = () => profile?.avatarId || null;
    const getUserName = () => profile?.name || null;
    const getUserEmail = () => profile?.email || null;
    const getMerchant = () => profile?.merchant || null;
    const getOperator = () => profile?.operator || null;

    return {
        isUserInRole,
        isUserInAnyRole,
        getUserId,
        getUserAvatarId,
        getUserName,
        getUserEmail,
        getMerchant,
        getOperator,
        getAccessLevel,
        isMerchantAccessLevel,
        isOperatorAccessLevel,
        isAdminAccessLevel,
        profile
    };
} 